var _a, _b, _c, _d, _e, _f;
import { default as IS_CLIENT } from "@pb/utils/constants/isClient";
import LegacyNotifyIfBack from './LegacyNotifyIfBack';
import NotifyIfBack from './NotifyIfBack';
export const shouldRenderLegacyVersion = process.env.NOTIFY_IF_BACK !== 'pb'
    ? IS_CLIENT ? !((_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.hm) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.notifyIfBack) === null || _c === void 0 ? void 0 : _c.version) ||
        ((_f = (_e = (_d = window === null || window === void 0 ? void 0 : window.hm) === null || _d === void 0 ? void 0 : _d.options) === null || _e === void 0 ? void 0 : _e.notifyIfBack) === null || _f === void 0 ? void 0 : _f.version) !== 'v2'
        : false
    : false;
export default shouldRenderLegacyVersion ? LegacyNotifyIfBack : NotifyIfBack;
//# sourceMappingURL=index.js.map